import {
  createSettingsParams,
  SettingsParamType,
  type ISettingsParam,
  type PartialBy,
} from '@wix/tpa-settings';
import {
  enumSettingsParam,
  textSettingsParam,
  AccessibilityHtmlTags,
  typedSettingsParam,
} from './settingsParamsUtils';
import {
  DockLocationOptions,
  ImageResizeOptions,
  ImageSizeOptions,
} from './types';
import { DataType } from '@wix/editor-platform-ooi-metadata-resolver';

export type ISettingsParamsDefinitions = {
  [key in keyof ISettingsParams]: PartialBy<
    ISettingsParam<ISettingsParams[key]>,
    'key'
  >;
};

export type ISettingsParams = {
  titleText: SettingsParamType.Text;
  titleTagName: SettingsParamType.String;
  showMoreDescriptionText: SettingsParamType.Text;
  showLessDescriptionText: SettingsParamType.Text;
  serviceImageSize: ImageSizeOptions;
  serviceImageResize: ImageResizeOptions;
  serviceImageDockLocation: DockLocationOptions;
  selectedServices: string[];
  serviceDescriptionFontHtmlTag: SettingsParamType.String;
  serviceNameFontHtmlTag: SettingsParamType.String;
};

export const settingsParamsDefinitions: ISettingsParamsDefinitions = {
  titleText: textSettingsParam('wix-services.title_text'),
  titleTagName: enumSettingsParam(AccessibilityHtmlTags.SecondaryHeading),
  showMoreDescriptionText: textSettingsParam(
    'wix-services.show_more_description_text',
  ),
  showLessDescriptionText: textSettingsParam(
    'wix-services.show_less_description_text',
  ),
  serviceImageSize: enumSettingsParam(({ isMobile }) =>
    isMobile ? ImageSizeOptions.MEDIUM : ImageSizeOptions.SMALL,
  ),
  serviceImageResize: enumSettingsParam(ImageResizeOptions.CROP),
  serviceImageDockLocation: enumSettingsParam(DockLocationOptions.MIDDLE),
  selectedServices: typedSettingsParam(
    DataType.container,
    SettingsParamType.Object,
    [],
  ),
  serviceDescriptionFontHtmlTag: enumSettingsParam(
    AccessibilityHtmlTags.Paragraph,
  ),
  serviceNameFontHtmlTag: enumSettingsParam(
    AccessibilityHtmlTags.SecondaryHeading,
  ),
};

export default createSettingsParams<ISettingsParams>(settingsParamsDefinitions);
